import { render, staticRenderFns } from "./follow-details-query.vue?vue&type=template&id=4e96778c"
import script from "./follow-details-query.vue?vue&type=script&lang=ts"
export * from "./follow-details-query.vue?vue&type=script&lang=ts"
import style0 from "./follow-details-query.vue?vue&type=style&index=0&id=4e96778c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports